<template>
    <div class="loader-container" v-bind:class="{ vanish: isConfiguratorLoaded }" v-bind:style="{ display: isLoadingScreenVisible ? '' : 'none' }" id="loaderContainer">
        <img v-bind:src="p_logoUrl" class="logo-img" />
        <div class="loader-text">
            <h2>
            Einen Moment Geduld, der
            {{ p_configuratorName }}
            <br> wird geladen...
            </h2>
            <br />
            <br />
            <p id="randomFact" v-show="p_randomFacts">Wussten Sie schon:
                {{ randomFactList[actualRandomFactIndex] }}
            </p>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    p_configuratorName: String,
    p_logoUrl: String,
    p_randomFacts: String,
  },
  data() {
    return {
      actualRandomFactIndex: 0,
      randomFactList: [],
      timerRandomFacts: null,
      timerConfiguratorLoaded: null,
      isConfiguratorLoaded: false,
      isLoadingScreenVisible: true,
    };
  },
  beforeUpdate() {
    this.loadingScreenUpdate();
    this.checkConfiguratorLoaded();
  },
  beforeMount() {
    this.loadingScreenUpdate();
    this.checkConfiguratorLoaded();
  },
  methods: {
    checkConfiguratorLoaded() {
      this.timerConfiguratorLoaded = setInterval(() => {
          if (this.$parent.checkConfiguratorReady() ) {
            this.setConfiguratorLoaded();
          }
      }, 1000);
      // this.setConfiguratorLoaded();
    },
    // startConfiguratorLoadedTimer() {
    //   // after 10 seconds the loadingscreen fades out
    //     if (this.timerConfiguratorLoaded == null) {
    //       this.timerConfiguratorLoaded = setInterval(() => {
    //       this.setConfiguratorLoaded();
    //       }, 15000);
    //     }
    // },
    setConfiguratorLoaded() {
        clearInterval(this.timerConfiguratorLoaded);
        // sets a timeout for the fade out animation
        // fade out animation takes 800 ms
        this.isConfiguratorLoaded = true;
        setTimeout(() => { 
            this.isLoadingScreenVisible = false;
            this.$parent.setConfiguratorLoaded();
            }, 800);
    },
    loadingScreenUpdate() {
      // initialize the random facts
      // random facts are seperated with ';'
      // set a timer for every 5 seconds to choose a random fact
      if (this.p_randomFacts != null) {
        this.cancelAutoUpdate();
        this.randomFactList = this.p_randomFacts.split(';');
        this.timerRandomFacts = setInterval(() => {
          this.chooseAndSetRandomFact();
        }, 5000);
      }
    },
    chooseAndSetRandomFact() {
      if (this.randomFactList.length > 1) {
        // Random number between 0 and randomFactList.length - 1
        let newRandom = Math.floor(Math.random() * this.randomFactList.length);
        // To secure that the value random number is not like the old one 
        while (newRandom === this.actualRandomFactIndex) {
          newRandom = Math.floor(Math.random() * this.randomFactList.length);
        }
        this.actualRandomFactIndex = newRandom;
      } else {
        this.actualRandomFactIndex = 0;
      }
    },
    cancelAutoUpdate() {
      if (this.timerRandomFacts != null) {
        clearInterval(this.timerRandomFacts);
      }
    },
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  },
};
</script>

<style language="css">
  @import '../../scss/loading_screen/style.css';
</style>



// WEBPACK FOOTER //
// src/components/configurator/LoadingScreen.vue